import { render } from "./template.vue?vue&type=template&id=6f26bc04&ts=true"
import script from "./template.vue?vue&type=script&lang=ts"
export * from "./template.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__